/* Convites de captador.

   O código não impede a criação da conta, e isso é de propósito: o Supabase
   aceita signUp direto da chave anon, que é pública. O que o código faz é
   LIBERAR o perfil. Conta criada sem convite nasce inativa e não enxerga
   nem grava nada, por causa das policies da migração 005.

   Por isso a validação é só uma cortesia para pegar erro de digitação antes
   de criar a conta. Quem decide de verdade é o Postgres, em usar_convite. */

import { sb } from "../supabase.js";

/* Gera um código. Só admin, conferido dentro da função no banco. */
export async function criarConvite(){
  const { data, error } = await sb.rpc("criar_convite");
  if (error) throw error;
  return data;
}

/* Lista para o admin acompanhar. O RLS já limita isto a admin. */
export async function listarConvites(){
  const { data, error } = await sb
    .from("convites")
    .select("codigo,criado_em,usado_por,usado_em")
    .order("criado_em", { ascending: false });
  if (error) throw error;
  return data || [];
}

/* Responde só sim ou não. Chamada por quem ainda não tem sessão. */
export async function codigoValido(codigo){
  const { data, error } = await sb.rpc("codigo_convite_valido", { p_codigo: codigo });
  if (error) throw error;
  return data === true;
}

/* Consome o código e libera o perfil de quem está logado. */
export async function usarConvite(codigo){
  const { data, error } = await sb.rpc("usar_convite", { p_codigo: codigo });
  if (error) throw error;
  return data === true;
}
